import {lazy, Suspense} from 'react';
import {Loading} from 'components/loading/Loading';
import {useAppOverrides} from 'contexts/AppOverridesContext';

/**
 * Default CIP team page, loaded lazily to keep the initial bundle small. Only
 * resolved when no {@link AppOverrides.TeamPage} override is present.
 */
const DefaultTeam = lazy(() => import('./default'));

/**
 * Route element for `/team`.
 *
 * Reads {@link AppOverrides.TeamPage} from {@link AppOverridesContext}:
 * - When an override is provided, renders it directly.
 * - Otherwise, renders the default CIP {@link Team} page behind a `<Suspense>`
 *   boundary so the lazy chunk is only fetched on demand.
 *
 * This lets external deploy wrappers (e.g. PAI) substitute a custom team page
 * without editing any CIP source file.
 *
 * @return The override team page when present, otherwise the default CIP team
 *   page inside a suspense boundary.
 * @throws Never.
 */
export function TeamPageRoute() {
  const {TeamPage} = useAppOverrides();
  if (TeamPage) {
    return <TeamPage />;
  }
  return (
    <Suspense fallback={<Loading />}>
      <DefaultTeam />
    </Suspense>
  );
}
